
<div [ngClass]="{'lente': blu, 'lente-bianca': !blu}">
    <button  class=" flex justify-center items-center cursor-pointer " [innerHTML]="myIcon" (click)="click"></button>

</div>
